import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Layout } from 'components/atoms'
import { InputBuild, SelectBuild } from 'components/molecules'
import { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { formFilter } from './form'
import { schema } from './schema'
import { FormFilterElements } from './types'

import { useCacheFilters } from 'hooks/useCacheFilters'
import { FilterContracts } from './interfaces'
import './style.css'

const initialState = {
    dataInicio: '',
    dataFim: '',
    numeroRegistroContrato: '',
    numeroContrato: '',
    chassi: '',
    tipoOperacao: '',
    placa: '',
    status: '',
    especie: '',
    nomeCredor: '',
    nomeDevedor: '',
    municipioDevedor: '',
    ufDevedor: '',
    marcaModelo: '',
    documentoDevedor: '',
    renavam: '',
    anoModelo: ''
}

interface FilterContractProps {
    handleFilterContracts: (value: FilterContracts) => void
    loadingFilter: boolean
}

export function FilterContract({
    handleFilterContracts,
    loadingFilter
}: FilterContractProps) {
    const formData = useMemo(() => formFilter, [formFilter])
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        setValue,
        reset
    } = useForm<FilterContracts>({
        resolver: yupResolver(schema),
        mode: 'onChange'
    })

    const { resetCacheFilters, getCacheFilters, hasCacheFilters } =
        useCacheFilters()

    const OPEN_TAB = [0]
    const CLOSE_TAB: any = []

    const defaultIndex = hasCacheFilters ? OPEN_TAB : CLOSE_TAB

    const setCacheFilters = () => {
        const cacheFilters = getCacheFilters()

        if (!cacheFilters) return

        cacheFilters?.filter &&
            Object.entries(cacheFilters.filter).forEach(([key, value]) => {
                setValue(`${key as keyof FilterContracts}`, value as any)
            })
    }

    const handleClear = () => {
        resetCacheFilters()
        reset({ ...initialState }, { keepDirtyValues: false })
    }

    const onSubmit = (value: FilterContracts) => {
        resetCacheFilters()
        handleFilterContracts(value)
    }

    useEffect(() => {
        setCacheFilters()
    }, [])

    return (
        <Accordion
            allowMultiple
            backgroundColor={'white'}
            marginBottom={4}
            defaultIndex={defaultIndex}
        >
            <AccordionItem>
                <h2>
                    <AccordionButton
                        backgroundColor={'white'}
                        className="white-hover"
                    >
                        <Box
                            as="h2"
                            flex="1"
                            textAlign="left"
                            fontSize={20}
                            fontWeight={700}
                        >
                            Filtrar contrato(s):
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h2>
                <AccordionPanel pb={4} backgroundColor={'white'}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box backgroundColor={'white'}>
                            <Layout type="row" gutter={{ y: 1.5 }}>
                                {formData.map(
                                    ({ layout, input, select }, key) => (
                                        <Layout {...layout} key={key}>
                                            {select ? (
                                                <SelectBuild
                                                    {...select}
                                                    err={
                                                        errors[
                                                            select.id as FormFilterElements
                                                        ]
                                                    }
                                                    {...register(
                                                        select.id as FormFilterElements
                                                    )}
                                                />
                                            ) : (
                                                input && (
                                                    <InputBuild
                                                        {...input}
                                                        err={
                                                            errors[
                                                                input.id as FormFilterElements
                                                            ]
                                                        }
                                                        {...register(
                                                            input.id as FormFilterElements
                                                        )}
                                                        value={watch(
                                                            input?.id as FormFilterElements
                                                        )}
                                                    />
                                                )
                                            )}
                                        </Layout>
                                    )
                                )}
                            </Layout>
                            <Box
                                paddingY={8}
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                gap={6}
                            >
                                <Button
                                    colorScheme="primary"
                                    variant="outline"
                                    onClick={handleClear}
                                >
                                    Limpar Campos
                                </Button>
                                <Button
                                    colorScheme="primary"
                                    type="submit"
                                    isLoading={loadingFilter}
                                >
                                    Filtrar
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    )
}
